import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const PrincipalSloObservationLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates, 
    psloDetails: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.user-summary.principal-slo',
        url: '/principal-slo',
        abstract: true
    },
    psloDetails: {
        name: 'authenticated.user-summary.principal-slo.details',
        url: '/details/:userId/:observationId'
    }
},
() => import('src/app/observations/principal-slo/principal-slo.module')
    .then((result: { PrincipalSloModule: any }) => result.PrincipalSloModule));
